import React from "react";
import { makeStyles } from "@mui/styles";
import { Chip, Grid, Typography } from "@mui/material";

const useStyles = makeStyles({
  invalidAccessCodeContainer: {
    display: "flex",
    flexDirection: "column",
    alignitems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
  },

  invalidAccessCodeTitle: {
    fontSize: " 2rem",
    // marginBottom: "1rem",
  },

  invalidAccessCodeDescription: {
    fontSize: "2.5rem",
    margin: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  invalidAccessCodeLink: {
    fontSize: "1rem",
    color: "blue",
    textDecoration: "none",
  },
});

const InvalidAccessCodeView = (errmsg) => {
  const classes = useStyles();
  return (
    <>
      <Grid
        style={{
          position: "absolute",
          width: "100%",
          backgroundColor: "#FFFBF6",
          height: "100px",
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          alignItems: "center",
        }}
      >
        {
          <div style={{ display: "flex", flexDirection: "column", alignItems: "start", paddingLeft: "20px" }}>
            <a href="https://techscore.ai" target="_blank" rel="noreferrer">
              <img
                src="https://yts-org-assets.s3.us-east-1.amazonaws.com/techscore.png"
                alt="LOGO"
                style={{ height: "42px" }}
              />
            </a>
            <Typography>
              <a
                href="https://techscore.ai "
                style={{ textDecoration: "none" }}
                color="#787878"
                target="_blank"
                rel="noreferrer"
              >
                <span style={{ fontWeight: "400", color: "#787878" }}>techscore.ai</span>
              </a>
            </Typography>
          </div>
        }
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "20px" }}></div>
      </Grid>
      <div className={classes.invalidAccessCodeContainer}>
        <h6 className={classes.invalidAccessCodeDescription}>
          <Chip sx={{ mr: 2, fontSize: "24px", height: 40 }} label={errmsg?.errmsg?.errorCode || "400"} color="error" />
          {errmsg?.errmsg?.errMsg || "Bad Request"}
        </h6>
        <h1 className={classes.invalidAccessCodeTitle}>
          {errmsg?.errmsg?.message || "This resource is not available."}
        </h1>
      </div>
    </>
  );
};

export default InvalidAccessCodeView;
